import React, { ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { DownOutlinedIcon } from 'assets/icons';
import {
  DropdownItem,
  DropdownMenu,
  SAntDropdown,
} from 'pages/MyOrdersPage/ClientsOrders/Filter/ClientsOrdersFilter.styled';
import { Checkbox, Flex, Icon, Text } from 'UI';

export interface MultiSelectItem {
  value: string;
  title: string;
  selected: boolean;
}

export interface MultiSelectFilterProps<T extends MultiSelectItem> {
  filters: T[];
  updateFilters: (filters: string) => void;
  getPlaceholders: (t: TFunction, selectedItems: T[]) => ReactNode;
}

export const MultiSelectFilter = <T extends MultiSelectItem>({
  filters,
  updateFilters,
  getPlaceholders,
}: MultiSelectFilterProps<T>) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const selected = filters.filter((item) => item.selected);

  const handleSelect = useCallback(
    (id: string) => {
      const clickedValue = filters.find((item) => item.value === id)?.selected;

      if (clickedValue) {
        updateFilters(
          selected
            .filter((e) => e.value !== id)
            .map((item) => item.value)
            .join('-'),
        );
      } else {
        updateFilters([...selected.map((item) => item.value), id].join('-'));
      }
    },
    [filters, selected, updateFilters],
  );

  const dropDownMenu = (
    <DropdownMenu direction={'column'}>
      {filters.map((item) => (
        <DropdownItem
          key={item.value}
          isSelected={item.selected}
          onClick={() => handleSelect(item.value)}
          align={'center'}
          gap={10}
        >
          <Checkbox checked={item.selected} />
          <Text type={item.selected ? 'search_result_highlighted' : 'text'} noWrap ellipsis>
            {item.title}
          </Text>
        </DropdownItem>
      ))}
    </DropdownMenu>
  );

  return (
    <SAntDropdown
      dropdownRender={() => dropDownMenu}
      trigger={['click']}
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      bordered={true}
    >
      <Flex justify={'space-between'} padding={'0px 11px'} align={'center'} gap={5}>
        {getPlaceholders(t, selected)}
        <Icon IconComponent={DownOutlinedIcon} size={14} mb={5} />
      </Flex>
    </SAntDropdown>
  );
};
